<!-- <iframe src="{{url}}" frameborder="0"></iframe> -->
<div class="text-lg font-medium tracking-tight leading-6 truncate titulo">&equiv; Vista previa</div>
<!-- <mat-icon svgIcon="mat_outline:close"></mat-icon> -->

<button mat-icon-button  mat-dialog-close style="float:right; margin-top: -30px;"
matTooltip="Cerrar">
    <mat-icon svgIcon="mat_outline:close"></mat-icon>
</button>

<!-- <mat-icon svgIcon="close"></mat-icon> -->
<hr>
<iframe [src]="urlSafe" width="100%" height="94%"></iframe>
